<template>
  <div style="width: 500px;">
    <div class="material-name" v-if="materialName">
      {{ materialName }}
    </div>
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Номер сертификата"
          placeholder="Введите номер сертификата"
          :required="true"
          :value="formData.certificate_number || ''"
          @change_input="(value) => onChange('certificate_number', value)"
        />
      </div>

      <div class="form__item form__item_inline">
        <CustomDate
          label="Дата выдачи сертификата"
          :value="formData.date_begin"
          @change_date="(value) => onChange('date_begin', value)"
          fullWidth
        />

        <CustomDate
          label="Срок действия сертификата"
          :value="formData.date_end"
          @change_date="(value) => onChange('date_end', value)"
          fullWidth
          :disabled="!formData.date_begin"
          :minDate="formData.date_begin"
        />
      </div>

      <div v-if="!isEdit" class="form__item">
        <CustomUploader
          :value="this.formData.file"
          :on-change="handleFileSelect"
          title="Файл сертификата"
        />
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { modifyProjectMaterialCertificate } from "@/views/ResidentialSettings/services";
import { useAppStore } from "@/services/store/app";
import CustomUploader from "@/components/form/CustomUploader";
import CustomDate from "@/components/form/CustomDate";

export default {
  name: "add-material-certificate",
  components: { CustomInput, CustomSelect, CustomModalFooter, CustomUploader, CustomDate },
  props: ["data"],
  data() {
    const projectId = this.data?.projectId || {};
    const material = this.data?.material || {};

    return {
      loading: false,
      projectId,
      formData: {
        material_id: material.material_id || "",
        certificate_number: material.certificate_number || "",
        project_material_certificate_id:
          material.project_material_certificate_id || null,
        date_begin: material.date_begin || "",
        date_end: material.date_end || "",
        file: null,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.formData.project_material_certificate_id;
    },
    materialName() {
      return this.data?.material?.material_name || "";
    },
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    handleFileSelect(file) {
      if (!file?.length) return;
      this.formData.file = file;
    },
    async onSubmit() {
      this.fileError = "";

      if (!this.formData.certificate_number) {
        return;
      }

      if (!this.isEdit && !this.formData.file?.length) {
        this.showErrorSnackbar("Выберите файл сертификата");
        return;
      }

      if (!this.projectId) return;

      this.loading = true;
      const body = {
        material_id: this.formData.material_id,
        certificate_number: this.formData.certificate_number,
        project_material_certificate_id:
          this.formData.project_material_certificate_id,
        date_begin: this.formData.date_begin || null,
        date_end: this.formData.date_end || null,
      };
      if (!this.isEdit) {
        body.file = this.formData.file[0];
      }
      const res = await modifyProjectMaterialCertificate(this.projectId, body);
      this.loading = false;
      if (!res) return;

      if (this.data?.onSubmit) {
        await this.data.onSubmit(res);
      }

      this.showSucceedSnackbar();
      this.closeModal();
    },
  },
  setup() {
    const { closeModal } = useAppStore();
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar, closeModal };
  },
};
</script>

<style scoped lang="scss">
.material-name {
  margin-top: 4px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #4a4a4a;
  font-weight: 500;
}

.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;
  margin-top: 15px;

  &__item {
    &.form__item_inline {
      display: flex;
      gap: 16px;

      :deep(.custom-date) {
        width: 100%;
        max-width: 100%;
      }
    }

    &_file {
      padding: 10px 7px;
      border-radius: 4px;
      border: 1px solid #ccc;
      color: #1f5ac2;
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}

.form__label {
  margin-bottom: 3px;
  font-size: 13px;
  display: block;
  color: #3b3b3b;
}

.form__file {
  margin-top: 4px;
}

.form__error {
  font-size: 12px;
  color: #dc2626;
}
</style>


